var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"splash-screen"}},[_c('v-icon',{staticStyle:{"color":"#a0a0a0","opacity":"0.5"},attrs:{"name":"sync","scale":"4","spin":""}}),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"15px","color":"#a0a0a0","font-size":"2em"}},[_vm._v(_vm._s(_vm.action))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bfa5449e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/component/FullScreenLoading.vue
// module id = null
// module chunks = 